import LoginForm from "./LoginForm"
import { useSelector } from "react-redux"
import { getQueryParams, redirectUser, staticBaseURI } from "../../../config"
import { useLocation } from "react-router-dom"

const LoginFormWrapper = () => {
    const { login, user } = useSelector((state) => state.auth)

    const location = useLocation()

    const redirect = getQueryParams(location.search, "redirect")

    if (login && redirect) {
        window.location.href = `${staticBaseURI}${decodeURIComponent(redirect)}`
    } else {
        redirectUser(user)
    }

    return (
        <section
            className="register-from-wrapper relative"
            style={{ backgroundImage: `url('./dists/images/auth-bg.jpg')` }}
        >
            <div className="background-overlay h-full w-full">
                <div className="container mx-auto px-10 py-20">
                    <div className="w-full md:w-[80%]">
                        <div className="text-center mb-4">
                            <div className="-ml-4 text-white text-xl font-bold hidden md:block">
                                OR
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="md:border-r-4 border-r-cyan-400 md:pr-8">
                                <LoginForm />
                            </div>
                            <div className="pl-4 text-center md:text-left mt-8 md:mt-0">
                                <div className="text-center mb-8 block md:hidden">
                                    <div className=" text-white text-xl font-bold">
                                        OR
                                    </div>
                                </div>
                                <a
                                    href={`${staticBaseURI}/register`}
                                    className="mt-8 uppercase font-bold text-2xl login-btn px-8 py-2"
                                >
                                    Sign Up
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default LoginFormWrapper
